import { NgModule } from '@angular/core';
import { BuContentComponent } from './bu-content/bu-content.component';

@NgModule({
  imports: [],
  declarations: [
    BuContentComponent
  ],
  exports: [
    BuContentComponent
  ]
})
export class BuContentModule { }
